import { useSearchParams, useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCanceled() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { language } = useLanguage();

  const userType = searchParams.get("type") as "seller" | "broker" | null;
  const paymentStep = searchParams.get("step") as "pre_evaluation" | "publication" | null;

  const getTitle = () => {
    if (language === "fr") {
      return "Paiement annulé";
    }
    return "Payment Canceled";
  };

  const getMessage = () => {
    if (language === "fr") {
      return "Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.";
    }
    return "Your payment has been canceled. No amount has been charged to your account.";
  };

  const getRetryPath = () => {
    if (userType === "broker") return "/register/brokers";
    return "/register/sellers";
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1D314D] via-[#2E4663] to-[#0f172a] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card rounded-xl shadow-xl p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-destructive/20 rounded-full flex items-center justify-center mb-4">
            <XCircle className="w-10 h-10 text-destructive" />
          </div>
          <h1 className="text-2xl font-bold text-foreground mb-2">
            {getTitle()}
          </h1>
        </div>

        <p className="text-muted-foreground mb-6">
          {getMessage()}
        </p>

        <div className="space-y-3">
          <Button 
            onClick={() => navigate(getRetryPath())} 
            className="w-full"
          >
            {language === "fr" ? "Réessayer" : "Try Again"}
          </Button>
          <Button 
            variant="outline" 
            onClick={() => navigate("/")} 
            className="w-full"
          >
            {language === "fr" ? "Retour à l'accueil" : "Back to Home"}
          </Button>
        </div>
      </div>
    </div>
  );
}
